<template>
    <app-title :title="trans['messages.gallery']" />
    <!-- eslint-disable max-len -->
    <section class="comic-gallery bg-no-repeat bg-top bg-cover bg-neutral-900">
        <div class="max-w-7xl mx-auto py-20 px-5">
            <h2 class="text-white text-2xl text-center mb-20 xl:text-3xl">
                {{ protagonistsAlbum.name }}
                <span v-if="protagonistsAlbum.description" class="block text-gray-400 text-lg xl:text-xl">
                    {{ protagonistsAlbum.description }}
                </span>
            </h2>
            <div v-if="protagonistsAlbum.pictures.length"
                 class="grid gap-10 grid-cols-1 sm:grid-cols-2 lg:grid-cols-5">
                <a v-for="picture in protagonistsAlbum.pictures"
                   :key="picture.id"
                   :href="picture.youtubeUrl
                       ? picture.youtubeUrl
                       : picture.path"
                   class="inline-block shadow relative group rounded-3xl"
                   data-lity>
                    <div class="absolute -inset-[2px] rounded-3xl border-2 border-transparent opacity-0 [background:linear-gradient(var(--color-slate-800),var(--color-slate-800))_padding-box,linear-gradient(to_top,var(--color-indigo-400),var(--color-cyan-400),var(--color-sky-500))_border-box] group-hover:opacity-100"></div>
                    <div class="relative">
                        <img :src="picture.thumbnail"
                             class="rounded-3xl hadow-lg"
                             alt="">
                    </div>
                </a>
            </div>
            <div v-else class="flex justify-center text-white">
                {{ trans['messages.coming_soon'] }}...
            </div>
        </div>
    </section>
    <section class="max-w-7xl mx-auto px-5 pt-20">
        <div v-for="album in albums"
             :key="album.id"
             class="flex flex-col rounded-3xl p-10 mb-20 bg-slate-800/60 ring-1 ring-slate-300/10">
            <h2 class="text-2xl bg-linear-to-r from-indigo-200 via-sky-400 to-indigo-200 bg-clip-text text-transparent xl:text-3xl mb-1">
                {{ album.name }}
            </h2>
            <h5 v-if="album.description" class="text-white text-lg xl:text-xl mb-10">
                {{ album.description }}
            </h5>
            <div v-if="album.pictures.length"
                 class="grid gap-10 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
                <a v-for="picture in album.pictures"
                   :key="picture.id"
                   :href="picture.youtubeUrl
                       ? picture.youtubeUrl
                       : picture.path"
                   class="inline-block shadow relative group rounded-3xl"
                   data-lity>
                    <div class="absolute -inset-[2px] rounded-3xl border-2 border-transparent opacity-0 [background:linear-gradient(var(--color-slate-800),var(--color-slate-800))_padding-box,linear-gradient(to_top,var(--color-indigo-400),var(--color-cyan-400),var(--color-sky-500))_border-box] group-hover:opacity-100"></div>
                    <div class="relative">
                        <img :src="picture.thumbnail"
                             class="rounded-3xl"
                             alt="">
                    </div>
                </a>
            </div>
            <div v-else class="flex justify-center">
                {{ trans['messages.coming_soon'] }}...
            </div>
        </div>
    </section>
    <!-- eslint-enable max-len -->
</template>

<script setup>
import { defineProps, defineOptions } from 'vue';
import Layout from '../../base/Layout';

require('lity');

defineProps({
    protagonistsAlbum: {
        type: Object,
        required: true
    },

    albums: {
        type: Array,
        required: true
    },

    trans: {
        type: Object,
        required: true
    }
});

defineOptions({
    layout: Layout
});
</script>
